/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getPieGraph(params) {
        return HttpService.get(environment.API_DS_360 + '/circle-chart', {
            params,
        });
    },
    getChartGraph(params) {
        return HttpService.get(environment.API_DS_360 + '/graph-chart', {
            params,
        });
    },
    searchList(params) {
        return HttpService.get(environment.API_DS_360 + '/search', {
            params,
        });
    },
    exportDS360(params) {
        return HttpService.get(environment.API_DS_360 + '/export', {
            params,
            responseType: 'blob',
        });
    },
};
